import React from 'react';
import styled from 'styled-components';
import { spacer16 } from '@spotify-internal/encore-web';
import { useT } from '@spotify-internal/i18n-core';
import {
  StyledIconExclamationActive,
  TypeWithMargin,
} from '@components/shared/styles';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  max-width: 300px;
`;

export const LoadingError = () => {
  const t = useT();

  return (
    <Content>
      <StyledIconExclamationActive
        iconSize={32}
        data-testid="exclamation-active-icon"
      />
      <TypeWithMargin
        variant="celloCanon"
        semanticColor="textBase"
        marginBottom={spacer16}
        marginTop={spacer16}
      >
        {t(
          'atlas.errors.error_loading',
          'Error loading',
          'Loading error state',
        )}
      </TypeWithMargin>
      <TextContainer>
        <TypeWithMargin variant="viola" semanticColor="textBase">
          {t(
            'atlas.errors.theres_a_problem',
            `There's a problem on our end and we can't show your content right now. Check back soon.`,
            'General error message',
          )}
        </TypeWithMargin>
      </TextContainer>
    </Content>
  );
};
